import signinDone from "./signinDone";
import signin from "./signin";
import otpLogin from "./otpLogin";

export default [signin, signinDone, otpLogin];
